// Marca de si SureKeep financia un extra: cuenta para la barra de crédito o va solo de contado.
import { cn } from '@/lib/cn';

export function FinancingBadge({
    financeable,
    className,
}: {
    financeable: boolean;
    className?: string;
}) {
    const label = financeable ? 'Financiable con SureKeep' : 'Solo contado';
    return (
        <span
            title={label}
            className={cn(
                'min-w-0 truncate rounded-full border px-1.5 text-[10px] leading-4',
                financeable
                    ? 'border-transparent bg-promo-soft font-medium text-promo'
                    : 'border-border text-muted-foreground',
                className,
            )}
        >
            {label}
        </span>
    );
}
